module.exports = __webpack_public_path__ + "img/payLogo2.f11ac732.png";